export default timetableService => {
    return function (input, key, filters) {

        var validDays = [],
            days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            dayFilter = filters[key],
            i;

        for (i = 0; i < dayFilter.length; i++) {
            if (dayFilter[i] === true) {
                validDays.push(days[i]);
            }
        }

        for (i = 0; i < input.length; i++) {
            if (!input[i].classes)
                continue;

            for (var j = 0, m = input[i].classes.length; j < m; j++) {
                var c = input[i].classes[j];
                if (c.meetingDay && validDays.indexOf(c.meetingDay) === -1) {
                    c[key + 'Filter'] = false;
                } else {
                    c[key + 'Filter'] = true;
                }
            }

            input[i] = timetableService.checkForVisibleChildren(input[i], filters);
        }
        return input;
    }
};